import { DesignTokens, GivelifyButton, GivelifyLabel } from '@givelify/ui';
import { styled } from '@mui/material';

export const Wrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
});

export const ImgWrapper = styled('div')(({ theme }) => ({
    marginTop: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('mobile')]: {
        marginTop: 0,
        '& img': {
            width: '190px',
        },
    },
}));

export const Title = styled(GivelifyLabel)(({ theme }) => ({
    maxWidth: '500px',
    textAlign: 'center',
    margin: '48px 0 32px',
    [theme.breakpoints.down('mobile')]: {
        maxWidth: '328px',
        fontSize: '20px',
    },
}));

export const Copyright = styled(GivelifyLabel)(({ theme }) => ({
    color: DesignTokens.color.globalNeutral600,
    margin: 'auto 0 26px',
    [theme.breakpoints.down('mobile')]: {
        display: 'none',
    },
}));

export const ActionButton = styled(GivelifyButton)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        fontSize: '16px',
        height: '48px',
    },
}));
